import MiniBagWrapper from '@moncler/components/minibag/MiniBagWrapper';
import { configureMinicartStore } from '@state';
import React from 'react';
import { Provider } from 'react-redux';
const store = configureMinicartStore();
const MiniBag = (props) => {
    // remove the saveMeasmerizeToken logic until clarifications on https://jira.industries-group.com/browse/OE-11549 by Measmerize
    // const remainingCallToUserInfo = useRef(5);
    // const saveAuth = useCallback((e?: any) => {
    //   if (e) {
    //     console.info('event from storage: ', e);
    //   }
    //   if (remainingCallToUserInfo.current > 0) {
    //     setTimeout(() => {
    //       api.getUserInfo().then((resp) => {
    //         //check if user is authenticated
    //         const auth = localStorage.getItem('measmerize:auth');
    //         if (resp?.isAuthenticated && auth != 'null' && resp?.measmerizeToken !== auth) {
    //           localStorage.setItem('measmerize:auth', auth);
    //           //add measmerize token to the user only if missing
    //           if (!resp?.measmerizeToken) {
    //             api.saveMeasmerizeToken(auth);
    //           }
    //         }
    //       });
    //     }, 500);
    //   }
    //   --remainingCallToUserInfo.current;
    // }, []);
    // useEffect(() => {
    // check if measmerize has already set token
    // const auth = localStorage.getItem('measmerize:auth');
    // console.info('init minibag');
    // if (!auth || auth == 'null') {
    // add listener to storage for measmerize
    //     saveAuth();
    //     window.addEventListener('storage', saveAuth, false);
    //   }
    //   return () => {
    //     console.info('remove minibag');
    //     window.removeEventListener('storage', saveAuth);
    //   };
    // }, []);
    return (React.createElement(Provider, { store: store },
        React.createElement(MiniBagWrapper, Object.assign({ faqurl: props.faqurl, totalItems: props.totalitems }, props))));
};
export default MiniBag;
